'use strict';

exports.__esModule = true;
function _broadcast(componentName, eventName, params) {
  if (this) {
    if (this.$refs[componentName]) {
      if (this.$refs[componentName].emitter) {
        this.$refs[componentName].emitter.emit.apply(this.$refs[componentName], [eventName].concat(params));
      } else {
        this.$refs[componentName].$emit.apply(this.$refs[componentName], [eventName].concat(params));
      }
    } else {
      _broadcast.apply(this.$refs[componentName], [componentName, eventName].concat([params]));
    }
  }
}
exports.default = {
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        if (parent.emitter && name !== 'WebmdCheckboxGroup') {
          parent.emitter.emit.apply(parent, [eventName].concat(params));
        } else {
          parent.$emit.apply(parent, [eventName].concat(params));
        }
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
};